import { IconPropsType } from '..';

export const AZColoredIcon = ({ ...props }: IconPropsType) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.825 15.1234C12.825 15.0981 12.8298 15.0731 12.8391 15.0496L14.779 10.1563C14.831 10.025 14.7343 9.88258 14.5931 9.88258H13.025C12.9145 9.88258 12.825 9.79304 12.825 9.68258V8.96774C12.825 8.85729 12.9145 8.76774 13.025 8.76775L16 8.76775C16.1104 8.76775 16.2 8.85729 16.2 8.96775V9.84438C16.2 9.86962 16.1952 9.89463 16.1859 9.91809L14.246 14.8115C14.1939 14.9427 14.2907 15.0852 14.4319 15.0852H16C16.1104 15.0852 16.2 15.1747 16.2 15.2852V16C16.2 16.1105 16.1104 16.2 16 16.2H13.025C12.9145 16.2 12.825 16.1105 12.825 16V15.1234Z"
        fill="#E9790C"
      />
      <path
        d="M3.06387 1.96573C3.08053 1.86994 3.16368 1.8 3.26091 1.8H4.61407C4.7113 1.8 4.79445 1.86994 4.81111 1.96573L6.03424 8.99799C6.05552 9.12031 5.96136 9.23226 5.8372 9.23226H5.08464C4.9842 9.23226 4.89934 9.15777 4.88632 9.05819L4.73752 7.91988C4.7245 7.8203 4.63964 7.74581 4.5392 7.74581H3.33577C3.23534 7.74581 3.15048 7.8203 3.13746 7.91988L2.98865 9.05819C2.97563 9.15777 2.89078 9.23226 2.79034 9.23226H2.03778C1.91362 9.23226 1.81946 9.12031 1.84074 8.99799L3.06387 1.96573ZM4.28662 6.81678C4.40944 6.81678 4.50324 6.70711 4.48421 6.58578L4.13507 4.36017C4.09972 4.13484 3.77525 4.13483 3.7399 4.36017L3.39077 6.58578C3.37174 6.70711 3.46554 6.81678 3.58835 6.81678H4.28662Z"
        fill="#E9790C"
      />
      <path
        d="M11.025 16C11.025 16.1105 10.9354 16.2 10.825 16.2H1.99999C1.88953 16.2 1.79999 16.1105 1.79999 16V14.5419C1.79999 14.4315 1.88953 14.3419 1.99999 14.3419H10.825C10.9354 14.3419 11.025 14.4315 11.025 14.5419V16Z"
        fill="#E2E3E4"
      />
      <path
        d="M6.52499 2C6.52499 1.88955 6.61453 1.8 6.72499 1.8L16 1.8C16.1104 1.8 16.2 1.88955 16.2 2V3.45807C16.2 3.56853 16.1104 3.65807 16 3.65807L6.72499 3.65807C6.61453 3.65807 6.52499 3.56852 6.52499 3.45807V2Z"
        fill="#E2E3E4"
      />
      <path
        d="M11.475 11.8194C11.475 11.9298 11.3854 12.0194 11.275 12.0194H1.99999C1.88953 12.0194 1.79999 11.9298 1.79999 11.8194V10.3613C1.79999 10.2508 1.88953 10.1613 1.99999 10.1613H11.275C11.3854 10.1613 11.475 10.2508 11.475 10.3613V11.8194Z"
        fill="#E2E3E4"
      />
      <path
        d="M7.42499 6.18065C7.42499 6.07019 7.51453 5.98065 7.62499 5.98065L16 5.98065C16.1104 5.98065 16.2 6.07019 16.2 6.18065V7.63871C16.2 7.74917 16.1104 7.83871 16 7.83871L7.62499 7.83871C7.51453 7.83871 7.42499 7.74917 7.42499 7.63871V6.18065Z"
        fill="#E2E3E4"
      />
    </svg>
  );
};
